import { TableCell, TableRow, Typography } from '@sanlam-glacier/app-common/components';
import { DocumentsRequired } from 'modules/case-tracking/types/documents-required/documents-required.types';
import { formatDateAsString } from 'utils/string-handling/human-readable-text';

type DocumentsRequiredRowProps = {
  row: DocumentsRequired;
};

const DocumentsRequiredRow = ({ row }: DocumentsRequiredRowProps) => {
  return (
    <TableRow hoverable={false} key={row.documentName}>
      <TableCell align={TableCell.ALIGN.LEFT} size={TableCell.SIZE.SMALL}>
        <Typography variant={Typography.VARIANT.B4}>{row.documentName}</Typography>
      </TableCell>
      <TableCell align={TableCell.ALIGN.LEFT} size={TableCell.SIZE.SMALL}>
        <Typography variant={Typography.VARIANT.B4}>
          {formatDateAsString(row.requestDate)}
        </Typography>
      </TableCell>
    </TableRow>
  );
};

export default DocumentsRequiredRow;
